import React from "react";
import PropTypes from "prop-types";
import { Avatar, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";

const SelectedStudentHeader = ({ student, onReset }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      mb={2}
      p={0}
      sx={{
        backgroundColor: darkMode ? "rgba(255,255,255,0.05)" : "#f8f9fa",
        borderRadius: "8px",
      }}
    >
      <MDBox display="flex" justifyContent="space-between" alignItems="center">
        <MDBox display="flex" alignItems="center">
          <Avatar
            src={student.foto || ""}
            sx={{ width: 56, height: 56, mr: 2 }}
          >
            {!student.foto && <Icon>person</Icon>}
          </Avatar>
          <MDBox>
            <MDTypography
              variant="h6"
              fontWeight="medium"
              color={darkMode ? "white" : "dark"}
            >
              {`${student.nombre || ""} ${student.apellido_paterno || ""} ${student.apellido_materno || ""}`}
            </MDTypography>
            <MDTypography variant="body2" color="text">
              No. Control: {student.numero_de_control || "-"} | CURP:{" "}
              {student.curp || "-"}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDButton variant="text" color="error" onClick={onReset}>
          Cambiar
        </MDButton>
      </MDBox>
    </MDBox>
  );
};

SelectedStudentHeader.propTypes = {
  student: PropTypes.shape({
    foto: PropTypes.string,
    nombre: PropTypes.string,
    apellido_paterno: PropTypes.string,
    apellido_materno: PropTypes.string,
    numero_de_control: PropTypes.string,
    curp: PropTypes.string,
  }).isRequired,
  onReset: PropTypes.func.isRequired,
};

export default SelectedStudentHeader;
